module.exports = "<div class=\"wizard text-center\">\n    <h1 [ngStyle]=\"customStyles\" class=\"h2\" tabindex=\"0\">{{ title }}</h1>\n    <h2 *ngIf=\"subTitle\" class=\"h3\" tabindex=\"0\">{{ subTitle }}</h2>\n    <div class=\"wizard-inner\">\n        <lbpa-breadcrumb (itemClicked)=\"itemClickedHandler($event)\" [currentItemNum]=\"currentItemIdx\" [finished]=\"finished\"\n                         [items]=\"items\"></lbpa-breadcrumb>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/lbpa-wizard/lbpa-wizard.component.html
// module id = 4N81
// module chunks = 1